"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLocationListOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22.82 16.74l.68.62.68-.62c.19-.18 4.82-4.49 4.82-9C29 4 27.05 2 23.5 2S18 4 18 7.73c0 4.52 4.63 8.83 4.82 9.01zM23.5 4C25.92 4 27 5.15 27 7.73s-2.32 5.57-3.5 6.85C22.32 13.3 20 10.46 20 7.73 20 5.15 21.08 4 23.5 4z" }),
        React.createElement("circle", { cx: 23.5, cy: 7.5, r: 1.5 }),
        React.createElement("path", { d: "M4 8h10v2H4zM4 14h10v2H4zM4 20h24v2H4zM4 26h24v2H4z" })));
}
exports.default = SvgLocationListOutline;
//# sourceMappingURL=LocationListOutline.js.map